module.exports = () => ({
  isOpen: false,
  numShown: 2,
  markers: markersData,
  search: '',
  isClicking: false,
  clickTO: Date.now(),
  clickDebounce: 200,
  listMarkers() {
    const markers = markersData.filter((marker) => {
      if (this.search === '') return true;

      return !!new RegExp(this.search, 'gi').test(marker.name) || this.search == marker.number;
    });

    markers.sort((A, B) => {
      const a = parseInt(A.number);
      const b = parseInt(B.number);

      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });

    return markers;
  },
  toggleFilterBox() {
    this.isOpen = !this.isOpen;
  },
  onFilterChange(e) {
    if (e && e.target.checked) {
      this.numShown += 1;
    } else {
      this.numShown -= 1;
    }

    this.$dispatch('on-filter-change');
  },
  showAll() {
    this.numShown = 3;

    for (const key in this.$store.global.filters) {
      this.$store.global.filters[key] = true;
    }

    this.onFilterChange();
  },
  isMarkerInactive(marker) {
    return this.$store.global.filters[marker.category] ? '' : 'isInactive';
  },
  navigateIfActive(marker) {
    if (this.$store.global.filters[marker.category]) {
      this.$dispatch('navigate', marker.slug);
      this.isOpen = false;
    }
  }
});
